import React, { useEffect, Component, useState, useCallback, useRef } from 'react';

import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Helmet } from 'react-helmet';
let apiServices = new ApiService();
const GoalSettings = () => {
  let history = useHistory();
  const [dob, setdob] = useState('');
  const [annuitydob, setAnnuityDob] = useState('');
  const [pensionage, setPensionAge] = useState('65');
  const [annuityage, setAnnuityAge] = useState('65');
  const [userCurrentAge, setUserCurrentAge] = useState('');
  const [ageStatus, setAgeStatus] = useState(0);
  const [ageannuityStatus, setAnnuityAgeStatus] = useState(0);
  const [spinnerLoading, setSpinnerLoading] = useState()
  const [step, setStep] = useState(1);
  const [n, setn] = useState();
  const [an, setan] = useState();
  const [t, setT] = useState('');
  const [at, setAt] = useState();
  const [p, setp] = useState('');
  const [ap, setap] = useState();
  const [x, setx] = useState();
  const [ax, setax] = useState();
  const [i, seti] = useState();
  const [ai, setai] = useState();
  const [i3, seti3] = useState();
  const [r, setr] = useState();
  const [ar, setar] = useState();
  const [r3, setr3] = useState();
  const [e, sete] = useState(9);
  const [ae, setae] = useState(9);
  const [q1, setq1] = useState(2);
  const [aq1, setAq1] = useState(2);
  const [s, sets] = useState();
  const [as, setas] = useState();
  const [sip, setsip] = useState();
  const [asip, setasip] = useState();
  const [sip3, setasip3] = useState();
  const [q, setq] = useState();
  const [n3, setn3] = useState();
  const [y, setY] = useState();
  const [needfor, setNeedfor] = useState('');
  const [anydetails4, setAnydetailsf4] = useState('');
  const [anydetails1, setAnydetailsf1] = useState('');
  const [anydetails2, setAnydetailsf2] = useState('');
  // const [flow3array, setFlow3Array] = useState(['2','3','4','5']);
  const [goal_type, setGoalType] = useState(0);
  const [customize_type, setCustomizeType] = useState('');
  const [customize, setCustomize] = useState(0);
  const [calcerror, setCalcError] = useState(0);
  const [annuitycalcerror, setAnnuityCalcError] = useState(0);
  const [calcerrorflow3, setcalcerrorflow3] = useState(0);
  const [q1msg, setq1msg] = useState(0);
  const [aq1msg, setAq1msg] = useState(0);
  const [sipsalaryerror, setSipSalaryError] = useState(0);
  const [sipannuitysalaryerror, setAnnuitySipSalaryError] = useState(0);
  const [portfolioname, setPortfolioname] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [increment, setIncrement] = useState(1);
  const [processbarflow3, setprocessbarflow3] = useState(0);
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      apiServices.themeGetRequest().then(result => {
        if (result.data.status == 'success') {
          setar(eval(result.data.data.gs_default_ror));
          setr(eval(result.data.data.gs_default_ror));
          setr3(eval(result.data.data.gs_default_ror));
          setai(eval(result.data.data.gs_default_roi));
          seti(eval(result.data.data.gs_default_roi));
          seti3(eval(result.data.data.gs_default_roi));
        }
      })
    }
    // a.classList.remove("completed");
    // a.setAttribute("class", "");
    agehandleChange(pensionage)
    annuityagehandleChange(annuityage)
    didMountRef.current = false;
  }, [annuityage][pensionage])
  const dobhandleChange = (event) => {
    if (event.target.name == 'dob') {
      var GivenDate = new Date(event.target.value);
      var CurrentDate = new Date();
      if (GivenDate > CurrentDate) {
        return false;
      }
      else {
        setdob(event.target.value);
        checkAge()
      }
    }
    else {
      var GivenDate = new Date(event.target.value);
      var CurrentDate = new Date();
      if (GivenDate > CurrentDate) {
        return false;
      }
      else {
        setAnnuityDob(event.target.value);
        AnnuityAge()
      }
    }
  }
  const agehandleChange = event => {
    setPensionAge(event);
    checkAge()
  }
  const annuityagehandleChange = event => {
    setAnnuityAge(event);
    AnnuityAge()
  }
  const checkAge = () => {
    let currentAge = 0;
    if (dob != '' && (pensionage >= 45 && pensionage <= 75)) {
      currentAge = calculate_age(dob)
      if (pensionage - currentAge > 5) {
        let yearsfromnow = pensionage - currentAge;
        setn(yearsfromnow)
        setAgeStatus(1)
      } else {
        setAgeStatus(2)
      }
    }
  }
  const AnnuityAge = () => {
    let currentAge = 0;
    if (annuitydob != '' && (annuityage >= 45 && annuityage <= 75)) {
      currentAge = calculate_age(annuitydob)
      if (annuityage - currentAge > 5) {
        let yearsfromnow = annuityage - currentAge;
        setan(yearsfromnow)
        setAnnuityAgeStatus(1)
      } else {
        setAnnuityAgeStatus(2)
      }
    }
  }
  const calcformulax = () => {
    processstep()
    let finalcalc = formulaamountcalc1(i, p, n)
    setx(finalcalc)
  }
  const calcformulaS = () => {
    processstep()
    let formulacalc2 = x * ((12 * 100) / (e - q1))
    sets(Math.round(formulacalc2))
 let SIP = formulaSIProundoff(r, n, formulacalc2, t, 1)
    if (SIP == 'calc_error') {
      setCalcError(1);
    }
    else if (SIP == 'sip_salary_error') {
      setSipSalaryError(1)
    }
    else {
      setSipSalaryError(0)
      setCalcError(0);
      setsip(SIP)
    }
  }
  const calcformulaAnnuityx = () => {
    processstep()
    let finalcalc = formulaamountcalc1(ai, ap, an)
    setax(finalcalc)
  }
  const calcformulaAnnuityS = () => {
    processstep()
    let formulacalc2 = ax * ((12 * 100) / ae - aq1)
    setas(Math.round(formulacalc2))
    let SIP = formulaSIProundoff(ar, an, formulacalc2, at, 2)
    if (SIP == 'calc_error') {
      setAnnuityCalcError(1);
    }
    else if (SIP == 'sip_salary_error') {
      setAnnuitySipSalaryError(1)
    }
    else {
      setAnnuitySipSalaryError(0)
      setAnnuityCalcError(0);
      setasip(SIP)
    }
  }
  const calculateYflow3 = () => {
    processstep()
    let finalcalc = formulaamountcalc1(i3, q, n3)
    setY(finalcalc)
    let SIP = formulaSIProundoff(r3, n3, finalcalc, 0, 3)
    if (SIP == 'calc_error') {
      setcalcerrorflow3(1)
    }
    else {
      setcalcerrorflow3(0)
      setasip3(SIP)
    }
  }
  const formulaamountcalc1 = (i, p, n) => {
    let formulacalc1 = (1 + (i / 1200))
    let finalcalc = Math.round(p * Math.pow(formulacalc1, 12 * n));
    return finalcalc;
  }
  const formulaSIProundoff = (r, n, amount, t, flow) => {
    let m = (r / 1200);
    let calc1 = (1 + m);
    let calc2 = Math.pow(calc1, 12 * n);
    let SIP1 = (amount * m) / (calc2 - 1)
    let SIP2 = Math.ceil(SIP1 / 500) * 500
    if (SIP2 <= 0 || SIP2 == null || SIP2 == undefined || SIP2 == '' || SIP2 == Infinity || isNaN(SIP2)) {
      return 'calc_error';
    }
    else if (SIP2 > 0.5 * t && flow != 3) {
      if (flow == 1) {
        setsip(SIP2)
      }
      if (flow == 2) {
        setasip(SIP2)
      }
      return 'sip_salary_error';
    }
    else {
      return SIP2;
    }
  }
  const restartprocess = () => {
    setStep(1);
  }
  const restartprocessflow2 = () => {
    setStep(7);
  }
  const restartprocessflow3 = () => {
    setStep(13);
  }
  const setportfolioname = () => {
    var a = document.getElementById("fow_bar" + increment);
    if (a != null) {
      a.setAttribute("class", "stepper-item completed");
    }
    setStep(16);
  }
  const processstep = () => {
    if (step == 1) {
      if (dob == null || dob == '') {
        setErrorMessage('Date of Birth field is required .')
        return false;
      }
      if (pensionage == null || pensionage == '') {
        setErrorMessage('Age at which you need pension field is required .')
        return false;
      }
      if (!(pensionage >= 45 && pensionage <= 75)) {
        setErrorMessage('Age doesnt seem right, keep it between 45 years and 75 years')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if (step == 2) {
      if (t == null || t == '') {

        setErrorMessage('Current monthly take home salary field is required .')
        return false;
      }
      if (p == null || p == '') {
        setErrorMessage('How much monthly pension would you need field is required .')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if (step == 3) {
      if (r == null || r == '') {
        setErrorMessage('Expected rate of return for accumulating for pension fund field is required .')
        return false;
      }
      else if (!(r >= 5 && r <= 25)) {
        setErrorMessage('Return seems too low / too high. Keep between 5% and 25%')
        return false;
      }
      if (i == null || i == '') {
        setErrorMessage('Expected rate of inflation field is required .')
        return false;
      }
      else if (!(i >= 2 && i <= 15)) {
        setErrorMessage('Assumption seems to low. / That assumption seems to high Keep between 2% to 15%')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if (step == 5) {
      if (e == null || e == '') {
        setErrorMessage('Expected rate of return on accumulated funds field is required .')
        return false;
      }
      if (!(e >= 6 && e <= 25)) {
        setErrorMessage('Return seems too low / too high. Keep between 6% and 25%')
        return false;
      }
      if (q1 > e - 6) {
        setq1msg(1)
        return false;
      }
      else {
        setq1msg(0)
      }
    }
    else {
      setErrorMessage('')
    }
    if ((step == 7)) {
      if (annuitydob == null || annuitydob == '') {
        setErrorMessage('Date of Birth field is required .')
        return false;
      }
      if (annuityage == null || annuityage == '') {
        setErrorMessage('Age at which you need annuity field is required .')
        return false;
      }
      else if (!(annuityage >= 45 && annuityage <= 75)) {
        setErrorMessage('Age doesnt seem right, keep it between 45 years and 75 years')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if ((step == 8) && (ap == null || ap == '')) {
      setErrorMessage('How much monthly annuity would you need field is required .')
      return false;
    }
    else {
      setErrorMessage('')
    }
    if ((step == 9)) {
      if (ar == null || ar == '') {
        setErrorMessage('Expected rate of return for accumulating for annuity fund field is required .')
        return false;
      }
      else if (!(ar >= 5 && ar <= 25)) {
        setErrorMessage('Return seems too low / too high. Keep between 5% and 25%')
        return false;
      }
      if (ai == null || ai == '') {
        setErrorMessage('Expected rate of inflation field is required .')
        return false;
      }
      else if (!(ai >= 2 && ai <= 15)) {
        setErrorMessage('Assumption seems to low. / That assumption seems to high Keep between 2% to 15%')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if (step == 11) {
      if (ae == null || ae == '') {
        setErrorMessage('Expected rate of return on accumulated funds field is required .')
        return false;
      }
      if (!(ae >= 6 && ae <= 25)) {
        setErrorMessage('Return seems too low / too high. Keep between 6% and 25%')
        return false;
      }
      if (aq1 > ae - 6) {
        setAq1msg(1)
        return false;
      }
      else {
        setAq1msg(0)
      }
    }
    else {
      setErrorMessage('')
    }
    if ((step == 13)) {
      if (q == null || q == '') {
        setErrorMessage('Money required field is required .')
        return false;
      }
      if (n3 == null || n3 == '') {
        setErrorMessage('Years field is required .')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    if ((step == 14)) {
      if (r3 == null || r3 == '') {
        setErrorMessage('Rate of return field is required .')
        return false;
      }
      if (i3 == null || i3 == '') {
        setErrorMessage('Rate of inflation field is required .')
        return false;
      }
    }
    else {
      setErrorMessage('')
    }
    var a = document.getElementById("fow_bar" + increment);

    if (a != null) {
      a.setAttribute("class", "stepper-item completed");
    }
    setStep(step + 1);
    setIncrement(increment + 1);
  }
  const processback = () => {
    setErrorMessage('')
    setIncrement(increment - 1);
    setStep(step - 1);
    var element = document.getElementById("fow_bar" + increment);
    element.classList.remove("completed");
  }
  const skipflow = () => {
    if (goal_type == 8) {
      history.push("/mutualfunds/sip")
    }
    else if (goal_type == 9) {
      history.push("/mutualfunds/lumpsum")
    } else {
      history.push("/mutualfunds")
    }
  }
  const submitgoalsettingsdata = () => {
    let flow = 0;
    let goaltype = '';
    let customize_type = 0;
    if (goal_type == '2' || goal_type == '3' || goal_type == '4' || goal_type == '5') {
      flow = 3;
    }
    else if (goal_type == '7') {
      if (customize_type == 13) {
        flow = 3;
      }
      else {
        flow = 2;
      }
    }
    else if (goal_type == '6') {
      flow = 0;
    }
    else {
      flow = 1;
    }
   if (goal_type == '2') {
      goaltype = 'Plan for buying a new house';
    }
    else if (goal_type == '3') {
      goaltype = 'Plan for Child’s education';
    }
    else if (goal_type == '4') {
      goaltype = 'Plan for Child’s Marriage';
    }
    else if (goal_type == '5') {
      goaltype = 'Plan for a vacation';
    }
    else if (goal_type == '6') {
      goaltype = 'Don’t have a goal, but want to invest';
    }
    else if (goal_type == '7') {
      customize_type = 1;
      if (customize_type == 13) {
        goaltype = 'Plan to accumulate (e.g for new Car)';
      }
      else {
        goaltype = 'Plan an annuity goal (e.g Monthly Pension)';
      }
    }
    else {
      goaltype = 'Plan for pension after retirement';
    }
   const dataString = {
      "gs_flow": flow,
      "gs_goal_type": goaltype,
      "gs_customize_goal": customize_type,
      "gs_any_details_f1": anydetails1,
      "gs_any_details_f4": anydetails4,
      "gs_any_details_f2": anydetails2,
      "gs_dob_f1": dob,
      "gs_age_f1": pensionage,
      "gs_years_f1": n,
      "gs_pension_f1": p,
      "gs_salary_f1": t,
      "gs_ror_f1": r,
      "gs_roi_f1": i,
      "gs_calculated_x_f1": x,
      "gs_ror_accumulated_funds_f1": e,
      "gs_pension_inc_rate_f1": q1,
      "gs_pension_corpus_f1": s,
      "gs_sip_f1": sip,
      "gs_dob_f2": annuitydob,
      "gs_age_f2": annuityage,
      "gs_years_f2": an,
      "gs_annuity_f2": ap,
      "gs_salary_f2": at,
      "gs_ror_f2": ar,
      "gs_roi_f2": ai,
      "gs_calculated_x_f2": ax,
      "gs_ror_accumulated_funds_f2": ae,
      "gs_pension_inc_rate_f2": aq1,
      "gs_pension_corpus_f2": as,
      "gs_sip_f2": asip,
      "gs_amount_need_for_f3": needfor,
      "gs_money_req_f3": q,
      "gs_after_years_f3": n3,
      "gs_ror_f3": r3,
      "gs_roi_f3": i3,
      "gs_calculated_y_f3": y,
      "gs_sip_f3": sip3,
      "gs_portfolio_name_f4": portfolioname,
    }
    apiServices.submitgoalsettingsdata(dataString).then(res => {
      if (res.data.status == 'success') {
        history.push("/dashboard");
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
      .catch(error => {
      })
  }
 const calculate_age = (dob1) => {
    var today = new Date();
    var birthDate = new Date(dob1);
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age_now--;
    }
    return age_now;
  }
  const customizegoal = (val) => {
    if (val == 7) {
      setGoalType(7)
      setStep(7)
      setCustomize(1);
    }
    else if (val == 6 || val == 8 || val == 9) {
      setGoalType(val);
      setStep(50);
      setCustomize(0);
    }
    else {
      setCustomize(0);
    }
  }
  return (
    <div>
      <Header />
      <Helmet>
        <title>GoalSettings - Goalstox</title>
        {/* <meta name="keywords" content={pageKeywords}/> 
        <meta name="description" content={pageDescription} /> */}
      </Helmet>
      <section className='bg-gray-light section-small'>
        <div className="container">
          <div className="row justify-content-md-center mb-50">
            <div className="col-lg-8">
              <h4 className="text-center mb-40 tx-theme">Let’s set a goal for you</h4>
              <div className="stepper-wrapper">
                <div id="fow_bar1" className="stepper-item">
                  <div className="step-counter"></div>
                </div>
                <div id="fow_bar2" className="stepper-item">
                  <div className="step-counter"></div>
                </div>
                <div id="fow_bar3" className="stepper-item">
                  <div className="step-counter"></div>
                </div>
                <div id="fow_bar4" className="stepper-item">
                  <div className="step-counter"></div>
                </div>

                {processbarflow3 == 0 ?
                  <div id="fow_bar5" className="stepper-item removeflow3">
                    <div className="step-counter"></div>
                  </div> : ''
                }
                {processbarflow3 == 0 ?
                  <div id="fow_bar6" className="stepper-item removeflow3">
                    <div className="step-counter"></div>
                  </div> : ''}
                {processbarflow3 == 0 ? <div id="fow_bar7" className="stepper-item removeflow3">
                  <div className="step-counter"></div>
                </div> : ''}
              </div>
              {
                step == 1 ?
                  <div id="step1" className="">
                    <h6>Find out the future value of your Goal & your Monthly Investment to achieve it</h6>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Goal Type</label>
                            <select name="goal_type" value={goal_type} onChange={(e) => { if (e.target.value != '6' && e.target.value != '8' && e.target.value != '9' && e.target.value != '7') { setCustomize(0); setGoalType(e.target.value); if (['2', '3', '4', '5'].includes(e.target.value)) { setStep(13); setprocessbarflow3(1); } else { setprocessbarflow3(0); setStep(eval(e.target.value)) } } else { customizegoal(e.target.value) } }}>
                              <option value="1">Plan for pension after retirement</option>
                              <option value="2">Plan for buying a new house</option>
                              <option value="3">Plan for Child’s education</option>
                              <option value="4">Plan for Child’s Marriage</option>
                              <option value="5">Plan for a vacation</option>
                              <option value="7">Plan my own customised Goal</option>
                              <option value="6">Don’t have a goal, but want to invest</option>
                              <option value="8">Start SIP</option>
                              <option value="9">Start Lumpsum Investment</option>
                            </select>
                          </div>
                        </div>
                        {customize == 1 ?
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>Select Customize Goal</label>
                              <select name="goal_type" value={customize_type} onChange={(e) => { if (e.target.value != '13') { setprocessbarflow3(0) } else { setprocessbarflow3(1) } setCustomizeType(e.target.value); setGoalType('7'); setStep(eval(e.target.value)) }}>
                                <option value="7">Plan an annuity goal (e.g Monthly Pension)</option>
                                <option value="13">Plan to accumulate (e.g for new Car)</option>
                              </select>
                            </div>
                          </div> : ''}
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Date Of Birth</label>
                            <input type="date" name="dob" value={dob} onChange={dobhandleChange} className="form-control" required /> </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Age at which you need pension</label>
                            <input type="number" name="pensionage" value={pensionage} onChange={(e) => { setPensionAge(e.target.value) }} className="form-control" /> </div>
                        </div>
                        {
                          ageStatus == 0 ? '' : ageStatus == 1 ? 'Good, let’s estimate how much pension you need' : 'Seems you don’t have a long time horizon, let’s see if it works out wel'
                        }
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Any details</label>
                            <textarea name="anydetails1" value={anydetails1} onChange={(e) => { setAnydetailsf1(e.target.value) }} placeholder="Add any details that you would like to retain for future, like assumptions, thought process behind it or anything else that is relevant to this goal"></textarea>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                    </div>
                  </div> : ''
              }
              {
                step == 2 ?
                  <div id="step2" className="">
                    <h5>Let’s now try and estimate how much do you need</h5>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your current monthly take home salary approximately ?</label>
                            <input type="number" name="monthysal" value={t} onChange={(e) => { setT(e.target.value); setp(Math.round((0.6 * e.target.value) / 1000) * 1000) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>How much monthly pension would you need Rs</label>
                            <input type="number" name="pension" value={p} onChange={(e) => { setp(e.target.value) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Don’t worry about inflation as yet. Just estimate what your expenses are today. Remove expenses like kid’s education, housing EMIs, loan EMIs and add some extra for medical expenses. As a ballpark, this should be around 50-60% of your current expenses. </label>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 3 ?
                  <div id="step3" className="">
                    <h5>Let’s get down to some assumptions...</h5>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of return for accumulating for pension fund</label>
                            <input type="number" name="rateofreturn" value={r} onChange={(e) => { setr(e.target.value) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of inflation</label>
                            <input type="number" name="number" value={i} onChange={(e) => { seti(e.target.value) }} className="form-control" />
                          </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Your expected rate of return depends upon your risk profile, your need for risk, you capacity and behavioural aspects. In general, including equities in higher percentage increases risk and also increases your rate of return.</label>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={calcformulax} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 4 ?
                  <div id="step4" className="">
                    <h3>Here we go</h3>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>You need a pension of <span className="tx-theme fw600">₹{p}</span> per month, start {n} years from now. However due to inflation, value of this money will reduce in {n} years. You will actually need <span className="tx-theme fw600">₹{x}</span> per month after 10 years, and this should increase every year by inflation, i.e {i}</label>
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 5 ?
                  <div id="step5" className="">
                    <h5>Let’s estimate return on accumulated pension fund</h5>
                    <div className="gform mt-20">
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Once you invest monthly and accumulate a pension corpus, you will then need to invest this corpus somewhere so that you can get monthly pension. What rate of return should you expect for this return ?</label>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>In general, you can buy this monthly pension plan from pension/ insurance companies. The return expected is slightly less than 10 year Government of India securities, and is normally not able to beat inflation.</label>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Or you can generate a higher return by investing in mutual funds, with systematic withdrawal plans.</label>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of return on accumulated funds ?</label>
                            <input type="number" name="roraccuumulatefund" value={e} onChange={(e) => { sete(e.target.value) }} className="form-control" />
                          </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Your pension will increase at the rate of {q1}% every year to counter inflation</label>
                            <input type="number" name="roraccuumulatefund" value={q1} onChange={(e) => { setq1(e.target.value) }} className="form-control" />
                          </div>
                        </div>
                      </div>
                      {
                        errorMessage != '' ?
                          <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                      }
                      {
                        q1msg == 1 ?
                          <div style={{ color: 'red' }}>At your expected rate of return {e} %, increasing pension more than {q1} % will be not feasible. Increase expected rate, or reduce increase in monthly pension</div> : ''
                      }
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={calcformulaS} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 6 ?
                  <div id="step6" className="">
                    <h3>Ok, so here we have it</h3>
                    {
                      calcerror == 1 ?
                        <div style={{ color: 'red' }}>“Oh ! Looks like the numbers are not working somehow. Try with different numbers ?”</div> : ''
                    }
                    {
                      sipsalaryerror == 1 ?
                        <ul>
                          <li>Your SIP required is more than half your salary <span className="tx-theme fw600">₹{sip}</span>.</li>
                          <li>You should start the SIP of at least <span className="tx-theme fw600">₹{Math.round(0.4 * t)}</span> and revise every year. Take forward for investment amount, allow changing of this amount if required</li>
                          <li>Or you can change your expectations and reduce pension amount</li>
                          <button type="button" className="mt-10 buttonab-line" onClick={(e) => { setStep(2) }}>Change Pension Amount<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                          <li className='mt-3'>Or postpone your retirement by few years</li>
                          <button type="button" className="mt-10 buttonab-line" onClick={(e) => { setStep(1) }}>Change retirement Age<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                          <div className='col-lg-12 mt-3'>
                            <div className="gform-box mg-b-20">
                              <label>Or invest 40% of your amount</label>
                              <input type="number" name="sipeoor" value={0.4 * sip} onChange={(e) => { setsip(e.target.value) }} className="form-control" />
                            </div>
                          </div>
                          {/* <input type="number" name="errorsipamount" value={errorsipamount} onChange={(e) => {if(e.target.value == null){setsip(errorsipamount)}else{setsip(e.target.value)}}} className="form-control" />  */}
                          <button type="button" onClick={setportfolioname} className="btn btn-primary mt-3 button01">Continue</button>

                        </ul> :
                        <div className="gform mt-20">
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>Your accumulated pension corpus needs to be <span className="tx-theme fw600">₹{s}</span></label>
                            </div>
                          </div>
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>And you need to invest monthly Rs <span className="tx-theme fw600">₹{sip}</span></label>
                            </div>
                          </div>

                          <div className='row'>
                            <div className='col-lg-3'>
                              <div className="gform-box mg-b-20">
                                <button type="button" onClick={processback} className="btn-primary mt-10 button03">Previous</button>
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className="gform-box mg-b-20">
                                <button type="button" onClick={restartprocess} className="btn-primary mt-10 button03">Try with diffrent numbers</button>
                              </div>
                            </div>
                            {calcerror == 0 ?
                              <div className='col-lg-3'>
                                <div className="gform-box mg-b-20">
                                  <button type="button" onClick={setportfolioname} className="btn-primary mt-10 button03">Continue</button>
                                </div>
                              </div> : ''
                            }
                          </div>
                        </div>
                    }
                  </div> : ''
              }
              {
                step == 7 ?
                  <div id="step7" className="">
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Goal Type</label>
                            <select name="goal_type" value={goal_type} onChange={(e) => { if (e.target.value != '6' && e.target.value != '8' && e.target.value != '9' && e.target.value != '7') { setCustomize(0); setGoalType(e.target.value); if (['2', '3', '4', '5'].includes(e.target.value)) { setprocessbarflow3(1); setStep(13) } else { setprocessbarflow3(0); setStep(eval(e.target.value)) } } else { customizegoal(e.target.value) } }}>
                              <option value="1">Plan for pension after retirement</option>
                              <option value="2">Plan for buying a new house</option>
                              <option value="3">Plan for Child’s education</option>
                              <option value="4">Plan for Child’s Marriage</option>
                              <option value="5">Plan for a vacation</option>
                              <option value="7">Plan my own customised Goal</option>
                              <option value="6">Don’t have a goal, but want to invest</option>
                              <option value="8">Start SIP</option>
                              <option value="9">Start Lumpsum Investment</option>
                            </select>
                          </div>
                        </div>
                        {customize == 1 ?
                          <div>
                            <div className='col-lg-12'>
                              <div className="gform-box mg-b-20">
                                <label>Select Customize Goal</label>
                                <select name="goal_type" value={customize_type} onChange={(e) => { if (e.target.value != '13') { setprocessbarflow3(0) } else { setprocessbarflow3(1) } setCustomizeType(e.target.value); setGoalType('7'); setStep(eval(e.target.value)) }}>
                                  <option value="7">Plan an annuity goal (e.g Monthly Pension)</option>
                                  <option value="13">Plan to accumulate (e.g for new Car)</option>
                                </select>
                              </div>
                            </div>
                            <div className='col-lg-12'>
                              <div className="gform-box mg-b-20">
                                <label>Set Portfolio Name</label>
                                <input type="text" name="goalname" value={portfolioname} onChange={(e) => { setPortfolioname(e.target.value) }} className="form-control" />
                              </div>
                            </div>
                          </div>
                          : ''}
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Date Of Birth</label>
                            <input type="date" name="annuitydob" value={annuitydob} onChange={dobhandleChange} className="form-control" required /> </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Age at which you need Annuity</label>
                            <input type="number" name="annuityage" value={annuityage} onChange={(e) => { setAnnuityAge(e.target.value) }} className="form-control" /> </div>
                        </div>
                        {
                          ageannuityStatus == 0 ? '' : ageannuityStatus == 1 ? 'Good, let’s estimate how much Annuity you need' : 'Seems you don’t have a long time horizon, let’s see if it works out wel'
                        }
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Any details</label>
                            <textarea name="anydetails2" value={anydetails2} onChange={(e) => { setAnydetailsf2(e.target.value) }} placeholder="Add any details that you would like to retain for future, like assumptions, thought process behind it or anything else that is relevant to this goal"></textarea>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      {customize == 1 ? <div style={{ color: 'red' }}>
                        <strong>Note :-</strong>
                        <p className='tx-11 mb-1'>- Annuity is regular flow of money on monthly, quarter, annual or any frequency basis like Pension.</p>
                        <p className='tx-11'>- Accumulation is simply saving every month to get large amount at a future date, like saving to buy a Car in future.</p>
                      </div> : ''}
                      <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                    </div>
                  </div> : ''
              }
              {
                step == 8 ?
                  <div id="step8" className="">
                    <h5>Let’s now try and estimate how much do you need</h5>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your current monthly take home salary approximately ?</label>
                            <input type="number" name="monthysal" value={at} onChange={(e) => { setAt(e.target.value); setap(Math.round((0.6 * e.target.value) / 1000) * 1000) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>How much monthly Annuity would you need Rs</label>
                            <input type="number" name="annuity" value={ap} onChange={(e) => { setap(e.target.value) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Don’t worry about inflation as yet. Just estimate what your expenses are today. Remove expenses like kid’s education, housing EMIs, loan EMIs and add some extra for medical expenses. As a ballpark, this should be around 50-60% of your current expenses. </label>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 9 ?
                  <div id="step9" className="">
                    <h5>Let’s get down to some assumptions...</h5>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of return for accumulating for Annuity fund</label>
                            <input type="number" name="rateofreturn" value={ar} onChange={(e) => { setar(e.target.value) }} className="form-control" /> </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of inflation</label>
                            <input type="number" name="number" value={ai} onChange={(e) => { setai(e.target.value) }} className="form-control" />
                          </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Your expected rate of return depends upon your risk profile, your need for risk, you capacity and behavioural aspects. In general, including equities in higher percentage increases risk and also increases your rate of return.</label>
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={calcformulaAnnuityx} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 10 ?
                  <div id="step10" className="">
                    <h3>Here we go</h3>
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>You need a Annuity of <span className="tx-theme fw600">₹{ap}</span> per month, start {an} years from now. However due to inflation, value of this money will reduce in {an} years. You will actually need <span className="tx-theme fw600">₹{ax}</span> per month after 10 years, and this should increase every year by inflation, i.e {ai}</label>
                          </div>
                        </div>
                      </div>
                     <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 11 ?
                  <div id="step11" className="">
                    <h5>Let’s estimate return on accumulated Annuity fund</h5>
                    <div className="gform mt-20">
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Once you invest monthly and accumulate a Annuity corpus, you will then need to invest this corpus somewhere so that you can get monthly annuity. What rate of return should you expect for this return ?</label>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>In general, you can buy this monthly annuity plan from annuity/ insurance companies. The return expected is slightly less than 10 year Government of India securities, and is normally not able to beat inflation.</label>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Or you can generate a higher return by investing in mutual funds, with systematic withdrawal plans.</label>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>What is your expected rate of return on accumulated funds ?</label>
                            <input type="number" name="roraccuumulatefund" value={ae} onChange={(e) => { setae(e.target.value) }} className="form-control" />
                          </div>
                        </div>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Your annuity will increase at the rate of {aq1}% every year to counter inflation</label>
                            <input type="number" name="roraccuumulatefund" value={aq1} onChange={(e) => { setAq1(e.target.value) }} className="form-control" />
                            {
                              errorMessage != '' ?
                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                            }
                            {
                              aq1msg == 1 ?
                                <div style={{ color: 'red' }}>At your expected rate of return {ae} %, increasing pension more than {aq1} % will be not feasible. Increase expected rate, or reduce increase in monthly pension</div> : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={calcformulaAnnuityS} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 12 ?
                  <div id="step12" className="">
                    <h3>Ok, so here we have it</h3>
                    {
                      annuitycalcerror == 1 ?
                        <div style={{ color: 'red' }}>“Oh ! Looks like the numbers are not working somehow. Try with different numbers ?”</div> : ''
                    }
                    {
                      sipannuitysalaryerror == 1 ?
                        <ul>
                          <li>Your SIP required is more than half your salary <span className="tx-theme fw600">₹{asip}</span>.</li>
                          <li>You should start the SIP of at least <span className="tx-theme fw600">₹{Math.round(0.4 * at)}</span> and revise every year. Take forward for investment amount, allow changing of this amount if required</li>
                          <li>Or you can change your expectations and reduce annuity amount</li>
                          <button type="button" className="mt-10 buttonab-line" onClick={(e) => { setStep(8) }}>Change Annuity Amount<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                         <li className='mt-3'>Or postpone your retirement by few years</li>
                          <button type="button" className="mt-10 buttonab-line" onClick={(e) => { setStep(7) }}>Change retirement Age<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                          <div className='col-lg-12 mt-3'>
                            <div className="gform-box mg-b-20">
                              <label>Or invest 40% of your amount</label>
                              <input type="number" name="asipeoor" value={0.4 * asip} onChange={(e) => { setasip(e.target.value) }} className="form-control" />
                            </div>
                          </div>
                          <button type="button" onClick={setportfolioname} className="btn btn-primary mt-3 button01">Continue</button>
                        </ul> :
                        <div className="gform mt-20">
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>Your accumulated annuity corpus needs to be Rs {as}</label>
                            </div>
                          </div>
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>And you need to invest monthly Rs {asip}</label>
                            </div>
                          </div>

                          <div className='row'>
                            <div className='col-lg-3'>
                              <div className="gform-box mg-b-20">
                                <button type="button" onClick={processback} className="btn-primary mt-10 button03">Previous</button>
                              </div>
                            </div>
                            <div className='col-lg-6'>
                              <div className="gform-box mg-b-20">
                                <button type="button" onClick={restartprocessflow2} className="btn-primary mt-10 button03">Try with diffrent numbers</button>
                              </div>
                            </div>
                            {annuitycalcerror == 0 ?
                              <div className='col-lg-3'>
                                <div className="gform-box mg-b-20">
                                  <button type="button" onClick={setportfolioname} className="btn-primary mt-10 button03">Continue</button>
                                </div>
                              </div> : ''
                            }
                          </div>
                        </div>
                    }
                  </div> : ''
              }
              {
                step == 13 ?
                  <div id="step13" className="">
                    <div className="gform mt-20">
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Goal Type</label>
                          <select name="goal_type" value={goal_type} onChange={(e) => { if (e.target.value != '6' && e.target.value != '8' && e.target.value != '9' && e.target.value != '7') { setCustomize(0); setGoalType(e.target.value); if (['2', '3', '4', '5'].includes(e.target.value)) { setStep(13); setprocessbarflow3(1) } else { setprocessbarflow3(0); setStep(eval(e.target.value)) } } else { customizegoal(e.target.value) } }}>
                            <option value="1">Plan for pension after retirement</option>
                            <option value="2">Plan for buying a new house</option>
                            <option value="3">Plan for Child’s education</option>
                            <option value="4">Plan for Child’s Marriage</option>
                            <option value="5">Plan for a vacation</option>
                            <option value="7">Plan my own customised Goal</option>
                            <option value="6">Don’t have a goal, but want to invest</option>
                            <option value="8">Start SIP</option>
                            <option value="9">Start Lumpsum Investment</option>
                          </select>
                        </div>
                      </div>
                      {customize == 1 ?
                        <div>
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>Select Customize Goal</label>
                              <select name="goal_type" value={customize_type} onChange={(e) => { if (e.target.value != '13') { setprocessbarflow3(0) } else { setprocessbarflow3(1) } setCustomizeType(e.target.value); setGoalType('7'); setStep(eval(e.target.value)) }}>
                                <option value="7">Plan an annuity goal (e.g Monthly Pension)</option>
                                <option value="13">Plan to accumulate (e.g for new Car)</option>
                              </select>
                            </div>
                          </div>
                          <div className='col-lg-12'>
                            <div className="gform-box mg-b-20">
                              <label>Set Portfolio Name</label>
                              <input type="text" name="goalname" value={portfolioname} onChange={(e) => { setPortfolioname(e.target.value) }} className="form-control" />
                            </div>
                          </div>
                        </div>
                        : ''}
                      {/* <div className="gform-box mg-b-20">
                            <select className="form-control" value={needfor} onChange={(e) => {setNeedfor(e.target.value)}}>
                            <option value="House">Your House</option>
                            <option value="Vacation">Your Vacation</option>
                            <option value="Child Marrige">Your Child’s Marriage</option>
                            </select>
                          </div> */}
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>How much money is required ? Rs</label>
                          <input type="number" name="moneyreq" value={q} onChange={(e) => { setq(e.target.value) }} className="form-control" />
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>And in how many years from now ? </label>
                          <input type="number" name="yearsfromnow3" value={n3} onChange={(e) => { setn3(e.target.value) }} className="form-control" />
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>Don’t worry about inflation as yet. Just estimate how much do you need in today’s value. </label>
                          {
                            errorMessage != '' ?
                              <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                          }
                        </div>
                      </div>
                      {/* <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                      <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                      </div>
                        </div> */}
                      {customize == 1 ? <div style={{ color: 'red' }}>
                        <strong>Note :-</strong>
                        <p className='tx-11 mb-1'>- Annuity is regular flow of money on monthly, quarter, annual or any frequency basis like Pension.</p>
                        <p className='tx-11'>- Accumulation is simply saving every month to get large amount at a future date, like saving to buy a Car in future.</p>
                      </div> : ''}
                      <button type="button" onClick={processstep} className="btn btn-primary mt-10 button01">Continue</button>
                    </div>
                  </div> : ''
              }
              {
                step == 14 ?
                  <div id="step14" className="">
                    <h5>Let’s make some estimates and assumptions ...</h5>
                    <div className="gform mt-20">
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>What is your expected rate of return</label>
                          <input type="number" name="ror3" value={r3} onChange={(e) => { setr3(e.target.value) }} className="form-control" />
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>What is your expected rate of inflation</label>
                          <input type="number" name="roi3" value={i3} onChange={(e) => { seti3(e.target.value) }} className="form-control" />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Your expected rate of return depends upon your risk profile, your need for risk, you capacity and behavioural aspects. In general, including equities in higher percentage increases risk and also increases your rate of return.</label>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <label>Inflation can slowly erode your wealth, and can make your plans go haywire. A correct estimate, and timely revision and rebalancing is important for you to succeed in your goals</label>
                          </div>
                        </div>
                      </div>
                      {
                        errorMessage != '' ?
                          <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                      }
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn btn-primary mt-10 button01">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={calculateYflow3} className="btn btn-primary mt-10 button01">Continue</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 15 ?
                  <div id="step15" className="">
                    <h3>Here is what you need ...</h3>
                    {
                      calcerrorflow3 == 1 ?
                        <div style={{ color: 'red' }}>“Oh ! Looks like the numbers are not working somehow. Try with different numbers ?”</div> : ''
                    }
                    <div className="gform mt-20">
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>At an inflation rate of {i3} you will need Rs <span className="tx-theme fw600">₹{y}</span> in {n3} years .</label>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className="gform-box mg-b-20">
                          <label>And you need a monthly investment of Rs <span className="tx-theme fw600">₹{sip3}</span></label>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-lg-3'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={processback} className="btn-primary mt-10 button03">Previous</button>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="gform-box mg-b-20">
                            <button type="button" onClick={restartprocessflow3} className="btn-primary mt-10 button03">Try with diffrent numbers</button>
                          </div>
                        </div>
                        {calcerrorflow3 == 0 ?
                          <div className='col-lg-3'>
                            <div className="gform-box mg-b-20">
                              <button type="button" onClick={processstep} className="btn-primary mt-10 button03">Continue</button>
                            </div>
                          </div> : ''
                        }
                      </div>
                    </div>
                  </div> : ''
              }
              {
                step == 16 ?
                  <div id="step16" className="">
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Give some name to this portfolio :</label>
                            <input type="text" name="portfolio_name" value={portfolioname} onChange={(e) => { setPortfolioname(e.target.value) }} className="form-control" /> </div>
                          {
                            errorMessage != '' ?
                              <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                          }
                        </div>
                        {/* <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Any details</label>
                            <textarea name ="anydetails4" value={anydetails4} onChange={(e) => {setAnydetailsf4(e.target.value)}} placeholder="Add any details that you would like to retain for future, like assumptions, thought process behind it or anything else that is relevant to this goal"></textarea>
                          </div>
                        </div> */}
                      </div>
                      <button type="button" onClick={submitgoalsettingsdata} className="btn btn-primary mt-10 button01">Continue</button>
                    </div>
                  </div> : ''
              }
              {
                step == 50 ?
                  <div id="step50" className="">
                    <div className="gform mt-20">
                      <div className='row'>
                        <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Goal Type</label>
                            <select name="goal_type" value={goal_type} onChange={(e) => { if (e.target.value != '6' && e.target.value != '8' && e.target.value != '9' && e.target.value != '7') { setCustomize(0); setGoalType(e.target.value); if (['2', '3', '4', '5'].includes(e.target.value)) { setStep(13); setprocessbarflow3(1) } else { setprocessbarflow3(0); setStep(eval(e.target.value)) } } else { customizegoal(e.target.value) } }}>
                              <option value="1">Plan for pension after retirement</option>
                              <option value="2">Plan for buying a new house</option>
                              <option value="3">Plan for Child’s education</option>
                              <option value="4">Plan for Child’s Marriage</option>
                              <option value="5">Plan for a vacation</option>
                              <option value="7">Plan my own customised Goal</option>
                              <option value="6">Don’t have a goal, but want to invest</option>
                              <option value="8">Start SIP</option>
                              <option value="9">Start Lumpsum Investment</option>
                            </select>
                          </div>
                        </div>
                        {/* {customize == 1?
                          <div className='col-lg-12'>
                          <div className="gform-box mg-b-20">
                            <label>Select Customize Goal</label>
                            <select name = "goal_type" value={customize_type} onChange={(e) => { setCustomizeType(e.target.value); setGoalType('7'); setStep(eval(e.target.value))} }>
                            <option value="7">Plan an annuity goal (e.g Monthly Pension)</option>
                            <option value="13">Plan to accumulate (e.g for new Car)</option>
                            </select>
                          </div>
                        </div>:''} */}
                      </div>
                      <button type="button" onClick={skipflow} className="btn btn-primary mt-10 button01">Continue</button>
                    </div>
                  </div> : ''
              }
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default GoalSettings;